import setMailboxAutoReplyConfigurationOperation from 'owa-service/lib/operation/setMailboxAutoReplyConfigurationOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
/**
 * Makes the call to the server to set automatic reply configuration
 * @param {MailboxAutoReplyConfigurationOptions} options automatic replies configuration to set on server
 * @returns promise of MailboxAutoReplyConfigurationOptions type
 */
export default function saveMailboxAutomaticRepliesConfiguration(options) {
    return setMailboxAutoReplyConfigurationOperation({
        Header: getJsonRequestHeader(),
        Options: options,
    });
}
//# sourceMappingURL=saveMailboxAutomaticRepliesConfiguration.js.map